import React, { useEffect } from 'react';
import { CountdownBar } from '../components/CountdownBar';
import { CTAButton } from '../components/CTAButton';
import { PurchasePopup } from '../components/PurchasePopup';
import { TestimonialCard } from '../components/TestimonialCard';
import { BonusCard } from '../components/BonusCard';
import { PricingCard } from '../components/PricingCard';
import { FAQSection } from '../components/FAQSection';
import { Check, BookOpen, Brain, Heart, Puzzle, Users, X, ShieldCheck, ArrowRight } from 'lucide-react';
export function LandingPage() {
  const checkoutUrl = 'https://checkout18.recursospro.shop/cart/47303343603961:1';
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-white font-sans text-gray-800 pb-20" data-id="element-69">
      <CountdownBar data-id="element-70" />
      <PurchasePopup data-id="element-71" />

      {/* HERO SECTION */}
      <header className="pt-20 pb-12 px-4 md:pt-24 md:pb-16 bg-white text-center relative overflow-hidden" data-id="element-72">
        <div className="max-w-4xl mx-auto relative z-10" data-id="element-73">
          <div className="inline-block bg-[#fbbf24] text-black font-bold px-4 py-1 rounded-full text-sm md:text-base mb-6 shadow-sm" data-id="element-74">
            🌈 Para docentes, profesionales y familias comprometidas con la
            inclusión
          </div>

          <h1 className="text-4xl md:text-6xl font-extrabold text-black leading-tight mb-4 tracking-tight" data-id="element-75">
            MEGAPACK INCLUSIVO INFANTIL
          </h1>

          <div className="flex justify-center mb-8" data-id="element-76">
            <img src="https://cdn.magicpatterns.com/uploads/38uhu92Qw4eaoejqdBXeKf/PROYECTOS_Anuales_(14).png" alt="MegaPack Inclusivo Infantil - Colección de recursos" className="w-full max-w-md md:max-w-lg drop-shadow-2xl rounded-lg transform hover:scale-105 transition-transform duration-500 cursor-pointer" onClick={scrollToPricing} data-id="element-77" />
          </div>

          <p className="text-xl md:text-2xl text-gray-600 font-medium max-w-2xl mx-auto mb-8" data-id="element-78">
            Todo el material inclusivo que necesitás, listo para usar.
          </p>

          <div className="bg-gray-50 border border-gray-200 p-6 rounded-xl max-w-3xl mx-auto mb-10 text-left md:text-center" data-id="element-79">
            <p className="text-lg text-gray-700" data-id="element-80">
              Recursos claros, organizados y adaptados para trabajar lenguaje,
              atención, inclusión y aprendizaje, sin pasar horas preparando ni
              empezar desde cero cada día.
            </p>
          </div>

          <div className="flex flex-col items-center gap-3" data-id="element-81">
            <CTAButton onClick={scrollToPricing} className="animate-bounce-subtle" data-id="element-82">
              👉 SÍ, QUIERO ACCEDER AHORA
            </CTAButton>
            <div className="flex items-center gap-2 text-sm text-gray-500" data-id="element-83">
              <ShieldCheck className="w-4 h-4" data-id="element-84" />
              <span data-id="element-85">Garantía de satisfacción de 7 días</span>
            </div>
          </div>
        </div>
      </header>

      {/* PROBLEM SECTION */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-86">
        <div className="max-w-3xl mx-auto" data-id="element-87">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-10" data-id="element-88">
            Si trabajás con niños, dejame hacerte una pregunta honesta
          </h2>

          <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 mb-10" data-id="element-89">
            <p className="text-xl font-semibold text-gray-800 mb-6" data-id="element-90">
              ¿Te pasa que preparar actividades inclusivas te cansa más que
              aplicarlas?
            </p>
            <p className="text-gray-600 mb-4" data-id="element-91">
              No porque no te importe la inclusión. No porque no tengas
              formación ni vocación.
            </p>
            <p className="text-gray-600 mb-4 font-bold" data-id="element-92">
              Sino porque cada día parece empezar desde cero.
            </p>
            <ul className="space-y-3 mt-6" data-id="element-93">
              {['Buscar actividades y adaptar materiales', 'Pensar variantes para cada necesidad', 'Armar recursos diferentes constantemente', 'Ordenar PDFs, fichas y juegos sueltos'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-94">
                  <X className="w-6 h-6 text-red-500 flex-shrink-0" data-id="element-95" />
                  <span className="text-gray-700" data-id="element-96">{item}</span>
                </li>)}
            </ul>
            <p className="mt-6 text-gray-800 italic border-l-4 border-red-400 pl-4 py-2 bg-red-50" data-id="element-97">
              Y cuando finalmente llega el momento de trabajar con los chicos…
              ya estás agotado/a.
            </p>
          </div>

          <div className="text-center" data-id="element-98">
            <p className="text-2xl font-bold text-[#2563eb]" data-id="element-99">
              👉 Acompañar la inclusión no debería sentirse así.
            </p>
          </div>
        </div>
      </section>

      {/* AGITATION SECTION */}
      <section className="py-16 px-4 bg-white" data-id="element-100">
        <div className="max-w-3xl mx-auto" data-id="element-101">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-4" data-id="element-102">
            El problema que casi nadie dice en voz alta
          </h2>
          <p className="text-center text-gray-600 mb-10" data-id="element-103">
            Si sos docente, acompañante terapéutico o profesional, esto
            seguramente te resulta familiar:
          </p>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-104">
            {['Pasás horas creando materiales desde cero', 'Tenés recursos, pero están desordenados', 'Buscás actividades inclusivas y nunca encontrás todo en un solo lugar', 'Improvisás más de lo que te gustaría', 'Sentís que los chicos necesitan más… y vos no llegás', 'Lo peor es esa sensación constante de: "Podría acompañarlos mejor… si tuviera el material listo."'].map((item, i) => <div key={i} className="bg-gray-50 p-5 rounded-lg border-l-4 border-gray-300" data-id="element-105">
                <p className="text-gray-700 font-medium" data-id="element-106">{item}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* SOLUTION SECTION */}
      <section className="py-16 px-4 bg-[#2563eb] text-white text-center" data-id="element-107">
        <div className="max-w-4xl mx-auto" data-id="element-108">
          <div className="inline-block bg-white text-[#2563eb] font-bold px-4 py-1 rounded-full mb-6" data-id="element-109">
            ✅ La solución
          </div>
          <h2 className="text-4xl md:text-5xl font-extrabold mb-6" data-id="element-110">
            MegaPack Inclusivo Infantil
          </h2>
          <p className="text-xl md:text-2xl opacity-90 mb-10 max-w-2xl mx-auto" data-id="element-111">
            Un sistema completo de recursos inclusivos, diseñado para que dejes
            de improvisar, ganes claridad y recuperes tu tiempo.
          </p>

          <div className="grid md:grid-cols-3 gap-6 text-gray-900 mb-10" data-id="element-112">
            <div className="bg-white p-6 rounded-xl shadow-lg" data-id="element-113">
              <div className="text-4xl mb-4" data-id="element-114">📂</div>
              <h3 className="font-bold text-lg mb-2" data-id="element-115">Abrís el material</h3>
              <p className="text-sm text-gray-600" data-id="element-116">
                Acceso inmediato a tu biblioteca digital organizada.
              </p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg" data-id="element-117">
              <div className="text-4xl mb-4" data-id="element-118">👆</div>
              <h3 className="font-bold text-lg mb-2" data-id="element-119">Elegís la actividad</h3>
              <p className="text-sm text-gray-600" data-id="element-120">
                Encontrás lo que necesitás según el área o necesidad.
              </p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg" data-id="element-121">
              <div className="text-4xl mb-4" data-id="element-122">🧩</div>
              <h3 className="font-bold text-lg mb-2" data-id="element-123">La aplicás</h3>
              <p className="text-sm text-gray-600" data-id="element-124">
                Listo para usar en el aula, consultorio o en casa.
              </p>
            </div>
          </div>

          <p className="text-xl font-bold mb-8" data-id="element-125">
            Sin vueltas. Sin improvisar. Sin perder horas.
          </p>

          <CTAButton onClick={scrollToPricing} className="bg-white text-[#2563eb] hover:bg-gray-100 border-b-[#1d4ed8]" data-id="element-126">
            👉 VER OFERTA ESPECIAL
          </CTAButton>
        </div>
      </section>

      {/* WHAT'S INCLUDED */}
      <section className="py-20 px-4 bg-gray-50" data-id="element-127">
        <div className="max-w-5xl mx-auto" data-id="element-128">
          <h2 className="text-3xl md:text-5xl font-bold text-center text-gray-900 mb-12" data-id="element-129">
            🌟 ¿Qué incluye exactamente el MegaPack?
          </h2>

          <div className="text-center mb-12" data-id="element-130">
            <span className="bg-green-100 text-green-800 font-bold px-4 py-2 rounded-lg text-lg" data-id="element-131">
              📚 Más de 500 recursos listos para usar
            </span>
          </div>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-132">
            {/* Category 1 */}
            <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-200" data-id="element-133">
              <div className="flex items-center gap-3 mb-6" data-id="element-134">
                <div className="bg-blue-100 p-3 rounded-full" data-id="element-135">
                  <span className="text-2xl" data-id="element-136">🗣️</span>
                </div>
                <h3 className="text-xl font-bold text-gray-900" data-id="element-137">
                  Lenguaje y Comunicación
                </h3>
              </div>
              <ul className="space-y-3" data-id="element-138">
                {['Lectoescritura y grafomotricidad', 'Tarjetas fonéticas y conciencia fonológica', 'Estimulación del vocabulario', 'Terapia de lenguaje infantil', 'Pack Lenguaje para Autismo'].map((item, i) => <li key={i} className="flex items-center gap-2 text-gray-700" data-id="element-139">
                    <Check className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-140" />
                    {item}
                  </li>)}
              </ul>
            </div>

            {/* Category 2 */}
            <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-200" data-id="element-141">
              <div className="flex items-center gap-3 mb-6" data-id="element-142">
                <div className="bg-purple-100 p-3 rounded-full" data-id="element-143">
                  <span className="text-2xl" data-id="element-144">🎲</span>
                </div>
                <h3 className="text-xl font-bold text-gray-900" data-id="element-145">
                  Atención, Conducta y Emociones
                </h3>
              </div>
              <ul className="space-y-3" data-id="element-146">
                {['Actividades para trabajar la atención', 'Juegos de concentración', 'Control de berrinches y enfados', 'Desarrollo emocional y conductual', 'Pack TDA / TDAH'].map((item, i) => <li key={i} className="flex items-center gap-2 text-gray-700" data-id="element-147">
                    <Check className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-148" />
                    {item}
                  </li>)}
              </ul>
            </div>

            {/* Category 3 */}
            <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-200" data-id="element-149">
              <div className="flex items-center gap-3 mb-6" data-id="element-150">
                <div className="bg-yellow-100 p-3 rounded-full" data-id="element-151">
                  <span className="text-2xl" data-id="element-152">🌈</span>
                </div>
                <h3 className="text-xl font-bold text-gray-900" data-id="element-153">
                  Inclusión y Necesidades Especiales
                </h3>
              </div>
              <ul className="space-y-3" data-id="element-154">
                {['Actividades para niños con TEA', 'Síndrome de Down', 'Dislexia y dificultades visuales/auditivas', 'Sordoceguera y limitaciones motrices', 'Material en Braille y accesibilidad'].map((item, i) => <li key={i} className="flex items-center gap-2 text-gray-700" data-id="element-155">
                    <Check className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-156" />
                    {item}
                  </li>)}
              </ul>
            </div>

            {/* Category 4 */}
            <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-200" data-id="element-157">
              <div className="flex items-center gap-3 mb-6" data-id="element-158">
                <div className="bg-pink-100 p-3 rounded-full" data-id="element-159">
                  <span className="text-2xl" data-id="element-160">🎨</span>
                </div>
                <h3 className="text-xl font-bold text-gray-900" data-id="element-161">
                  Juegos y Recursos Creativos
                </h3>
              </div>
              <ul className="space-y-3" data-id="element-162">
                {['Pictogramas y juegos inclusivos', 'Actividades lúdicas', 'Cuadernos prácticos', 'Material artístico y de expresión', 'Todo organizado en carpetas digitales'].map((item, i) => <li key={i} className="flex items-center gap-2 text-gray-700" data-id="element-163">
                    <Check className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-164" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* BEFORE VS AFTER */}
      <section className="py-16 px-4 bg-white" data-id="element-165">
        <div className="max-w-4xl mx-auto" data-id="element-166">
          <h2 className="text-3xl font-bold text-center mb-10" data-id="element-167">
            Antes vs Después
          </h2>
          <div className="grid md:grid-cols-2 gap-0 md:gap-8" data-id="element-168">
            <div className="bg-red-50 p-8 rounded-t-2xl md:rounded-2xl border border-red-100" data-id="element-169">
              <h3 className="text-xl font-bold text-red-600 mb-6 flex items-center gap-2" data-id="element-170">
                <X className="w-6 h-6" data-id="element-171" /> Antes del MegaPack
              </h3>
              <ul className="space-y-4" data-id="element-172">
                {['Improvisación constante', 'Cansancio mental', 'Falta de materiales adaptados', 'Estrés diario', 'Poco tiempo para los chicos'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-700" data-id="element-173">
                    <X className="w-5 h-5 text-red-400" data-id="element-174" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="bg-green-50 p-8 rounded-b-2xl md:rounded-2xl border border-green-100 relative overflow-hidden" data-id="element-175">
              <div className="absolute top-0 right-0 bg-green-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-176">
                TU NUEVA REALIDAD
              </div>
              <h3 className="text-xl font-bold text-green-600 mb-6 flex items-center gap-2" data-id="element-177">
                <Check className="w-6 h-6" data-id="element-178" /> Después del MegaPack
              </h3>
              <ul className="space-y-4" data-id="element-179">
                {['Actividades claras y progresivas', 'Material listo siempre', 'Inclusión real y organizada', 'Más confianza', 'Más disfrute al enseñar'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-700" data-id="element-180">
                    <Check className="w-5 h-5 text-green-500" data-id="element-181" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* BONUSES SECTION */}
      <section className="py-16 px-4 bg-gray-900 text-white" data-id="element-182">
        <div className="max-w-6xl mx-auto" data-id="element-183">
          <div className="text-center mb-12" data-id="element-184">
            <span className="text-[#fbbf24] font-bold tracking-widest uppercase text-sm mb-2 block" data-id="element-185">
              Solo por hoy
            </span>
            <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-186">
              🎁 Regalos especiales – GRATIS HOY
            </h2>
            <p className="text-gray-400 text-lg" data-id="element-187">
              Al ordenar hoy, te llevás estos 3 bonos exclusivos sin costo
              adicional.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-12" data-id="element-188">
            <BonusCard title="Bono #1: +98 Libros para Colorear" description={['Animales, frutas, objetos y mandalas', 'Atención y motricidad fina', 'Listos para imprimir']} imageSrc="https://cdn.magicpatterns.com/uploads/kKcUc7dWyLVVc1LAqVNPXp/PROYECTOS_Anuales_(15).png" data-id="element-189" />
            <BonusCard title="Bono #2: Mini Pack Atención" description={['Juegos cortos (5–10 minutos)', 'Ideal para pausas activas', 'Para aula y hogar']} imageSrc="https://cdn.magicpatterns.com/uploads/aYTvDJ626XcM7NXEVHKbsJ/PROYECTOS_Anuales_(16).png" data-id="element-190" />
            <BonusCard title="Bono #3: Guía Control Emociones" description={['Consejos prácticos', 'Actividades rápidas', 'Ideal para docentes y familias']} imageSrc="https://cdn.magicpatterns.com/uploads/rivseEtD5m5kimjU7KSD32/PROYECTOS_Anuales_(17).png" data-id="element-191" />
          </div>
        </div>
      </section>

      {/* PRICING SECTION */}
      <section id="pricing" className="py-20 px-4 bg-gradient-to-b from-white to-gray-50" data-id="element-192">
        <div className="max-w-4xl mx-auto text-center mb-10" data-id="element-193">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-194">
            ⏰ Oferta por tiempo limitado
          </h2>
          <p className="text-xl text-gray-600" data-id="element-195">
            Todo lo que necesitás para potenciar la inclusión, a una fracción de
            su valor real.
          </p>
        </div>

        <PricingCard data-id="element-196" />

        <div className="max-w-2xl mx-auto mt-12 bg-white p-6 rounded-xl border border-gray-200 shadow-sm flex flex-col md:flex-row items-center gap-6" data-id="element-197">
          <div className="bg-yellow-100 p-4 rounded-full flex-shrink-0" data-id="element-198">
            <ShieldCheck className="w-10 h-10 text-yellow-600" data-id="element-199" />
          </div>
          <div className="text-center md:text-left" data-id="element-200">
            <h3 className="font-bold text-lg text-gray-900 mb-1" data-id="element-201">
              Garantía sin riesgo
            </h3>
            <p className="text-gray-600" data-id="element-202">
              Probalo durante 7 días. Si no es para vos, te devolvemos el 100%
              del dinero. Sin preguntas. Sin letra chica.
            </p>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-203">
        <div className="max-w-6xl mx-auto" data-id="element-204">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-205">
            Lo que dicen otros profesionales
          </h2>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-206">
            <TestimonialCard name="Laura Fernández" location="Buenos Aires" quote="Me ahorra horas de preparación. Ahora tengo todo listo y adaptado para mis alumnos." data-id="element-207" />
            <TestimonialCard name="Agustina Godoy" location="Santa Fe" quote="Antes improvisaba, hoy trabajo con seguridad y materiales de calidad." data-id="element-208" />
            <TestimonialCard name="María Fucchili" location="Córdoba" quote="Volví a disfrutar mis clases porque sé que siempre tengo recursos adecuados a cada necesidad." data-id="element-209" />
            <TestimonialCard name="Carla Méndez" location="Mendoza" quote="Increíble la cantidad de recursos. Lo uso tanto en el consultorio como para recomendar actividades a los padres." data-id="element-210" />
            <TestimonialCard name="Sofía Ramírez" location="Tucumán" quote="La organización por carpetas es excelente. Encuentro lo que necesito en segundos. ¡Súper recomendado!" data-id="element-211" />
          </div>

          <div className="text-center mt-10" data-id="element-212">
            <CTAButton onClick={scrollToPricing} data-id="element-213">
              👉 QUIERO UNIRME A ELLAS
            </CTAButton>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-16 px-4 bg-white" data-id="element-214">
        <div className="max-w-3xl mx-auto" data-id="element-215">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-10" data-id="element-216">
            Preguntas frecuentes
          </h2>
          <FAQSection data-id="element-217" />
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-gray-900 text-gray-400 py-12 px-4 text-center" data-id="element-218">
        <div className="max-w-4xl mx-auto" data-id="element-219">
          <div className="mb-8" data-id="element-220">
            <h3 className="text-2xl font-bold text-white mb-4" data-id="element-221">
              La inclusión puede ser más simple
            </h3>
            <p className="mb-6" data-id="element-222">
              No necesitás más esfuerzo. Necesitás un sistema que te sostenga.
            </p>
            <CTAButton onClick={scrollToPricing} className="text-lg py-3 px-8" data-id="element-223">
              👉 Accedé ahora al MegaPack
            </CTAButton>
          </div>

          <div className="border-t border-gray-800 pt-8 text-sm" data-id="element-224">
            <p className="mb-2" data-id="element-225">
              © 2026 MegaPack Inclusivo Infantil – Todos los derechos
              reservados
            </p>
            <div className="flex justify-center gap-4" data-id="element-226">
              <span data-id="element-227">Privacidad</span>
              <span data-id="element-228">·</span>
              <span data-id="element-229">Términos y Condiciones</span>
            </div>
          </div>
        </div>
      </footer>
    </div>;
}